import "./Portfolio.module.css";
import Header from "@/reusable_sections/Header";
import Engine from "./sections/Engine";
import Footprint from "./sections/Footprint";
import IndustryTrust from "./sections/IndustryTrust";
import Growth from "./sections/Growth";
import GrowthCIPS from "./sections/GrowthCIPS";
import Expertise from "./sections/Expertise";
import Strategist from "./sections/Strategist";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
import Flyers from "./sections/Flyers";
export default function PortfolioPage() {
  return <div>
      <Header />
      <Engine />
      <Flyers />
      <Footprint />
      <IndustryTrust />
      <Growth />
      <GrowthCIPS />
      <Expertise />
      <Strategist />
      <Contact />
      <Footer />
    </div>;
}